import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import { Image, Result, Input, Menu, Table, Button, Select,Empty,Spin } from 'antd';
import {CloseOutlined} from '@ant-design/icons';
import RightArrow from '../../Assets/Images/right_arrow.png'
import CartImg from '../../Assets/Images/cart.png'
import DummyCayegory from '../../Assets/Images/dummy_category.png'
import API from '../../ApiService/ApiService';
import { categoryStart, categorySuccess, categoryFailure } from '../../Store/Slice/CategorySlice';
import { productStart, productSuccess, productFailure } from '../../Store/Slice/ProductSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams, useNavigate, createSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { WEB_URL } from '../../config';
const { Search } = Input;
const AllProducts = () => {
  //useState
  const [loading, setLoading] = useState(false);
  const [proLoading, setProLoading] = useState(false);
  const [menu, setMenu] = useState([]);
  const [pageLaoding, setPageLoading] = useState(false);
  const [brudchumb, setBrudchumb] = useState([]);
  const [finalFilteredData, setFinalFilteredData] = useState([]);
  const [productTable,setProductTable] = useState([]);
  const api = new API();
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  //redux
  const category_list = useSelector((state) => state?.category?.categorylist?.data);
  const category_last_list = useSelector((state) => state?.category?.categorylastlevel?.data);
  // const category_fulllast_list = useSelector((state) => state?.category?.categoryfulllist?.data);
  const product_last_list = useSelector((state) => state?.product?.productlistlastlevel?.data);
  //
  const prevSearchParams = new URLSearchParams(window.location.search);
  useEffect(() => {
    loadAllCategoryList();
    getInitProductRelated();
    setPageLoading(false);
  }, []);



  const loadAllCategoryList = async () => {
    await api.getAll(dispatch, [categoryStart, categorySuccess, categoryFailure, "categoryfulllist"], 'category/fulllist', {}, (err, res) => {
      if (err) {
        
        dispatch(categoryFailure());
        dispatch(categorySuccess({ type: "categoryfulllist", data: [] }));
      } else {
        const result = res?.data?.data;
        menuThree(null, result);
      }
    });
  }

 



  const getInitProductRelated = async () => {
    setProLoading(true);
    const prevSearchParams = new URLSearchParams(window.location.search);
    const filter = {};
    // filter.category_id = category_last_list?._id;
    // Add previous search parameters
    for (const [key, value] of prevSearchParams.entries()) {
      if (value !== '') {
        filter[key] = value;
      }
    }

    await api.getAll(dispatch, [productStart, productSuccess, productFailure, "productlistlastlevel"], 'product/lastlevel', filter, (err, res) => {
      setProLoading(false);
      if (err) {
        dispatch(productFailure());
        dispatch(productSuccess({ type: "productlistlastlevel", data: [] }));
      }else {
        setProductTable(res?.data?.data);
      }
    })
  }


  // Get the current path
  let currentLocation = window.location.pathname;
  // currentLocation.replace('/our-product/our-product/', '/our-product/');
  // Remove the trailing slash if it exists
  if (currentLocation.endsWith('/')) {
    currentLocation = currentLocation.slice(0, -1);
  }
  

  function getItem(label, key, icon, children, type,breadchumb,slug) {
    return {
      key,
      icon,
      children,
      label,
      type,
      breadchumb:breadchumb?breadchumb:[],
      slug:slug?slug:undefined,
    };
  }

  const menuThree = (parent, menu, url = '', breadcrumbs = []) => {
    const filter = menu?.filter((e) => String(e?.parent_id) === String(parent));
    const list = filter.map((e) => {
      const cat_url = `${url === '' ? '/category' : url}/${e?.slug}`;
      const newBreadcrumbs = [...breadcrumbs, { label: e?.name, url: cat_url }];
      return getItem(
        <Link to={cat_url}>{e?.name}</Link>,
        e?._id,
        '',
        menuThree(e._id, menu, cat_url, newBreadcrumbs)?.length > 0 ? menuThree(e._id, menu, cat_url, newBreadcrumbs) : null,
        "",
        newBreadcrumbs,
        e?.slug,
      );
    });
    setMenu(list);
    return list;
  };
  
  
  const rootSubmenuKeys = ['sub1', 'sub2', 'sub4'];

  const [openKeys, setOpenKeys] = useState(['sub1']);
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };
  const columns = [
    {
      title: 'Product Name',
      dataIndex: 'name',
      key: 'name',
      
    },
    {
      title: 'Category',
      dataIndex: 'description',
      key: 'description',
      render: (description) => {
        function truncateString(str, maxLength) {
          if (str?.length > maxLength) {
            return str?.substring(0, maxLength) + '...';
          }
          return str;
        }
        const truncatedDescription = truncateString(description, 200);
        return (
          <div dangerouslySetInnerHTML={{ __html: truncatedDescription }}></div>
        );
      }

    },
    {
      title: 'Pricing',
      dataIndex: 'action',
      key: 'action',
      width: 100,
      // fixed: 'right',
      render: (data, action) => (
        <Link to={`/product/${data}`}>
          <Button htmlType="button" type='link' className='view_product_btn'>
            View <img src={RightArrow} alt="right-arrow" />
          </Button>
        </Link>
      ),
    },
  ];
  const data = [];

  productTable?.map((item, index) => {
    data.push({
      key: index,
      name: <div className="table_name">
        <img src={item?.image[0]?.image_path ? api?.apiUrl + item?.image[0]?.image_path : DummyCayegory} alt="category" />
        <p>{item?.name}</p>
      </div>,
      description: item?.category?.map((e, i) => {
        return e?.name;
      }).join(", "),      
      action: item?.slug,
    });
  });

  const handleChange = async (value) => {
    // const currentSearchParams = new URLSearchParams(window.location.search);
    // currentSearchParams.set('sort_by', value);
    // navigate({
    //   pathname: `${currentLocation}`,
    //   search: `?${currentSearchParams.toString()}`,
    // });

    // const filter = {};
    // filter.category_id = category_last_list?._id;
    // // Add previous search parameters
    // for (const [key, value] of currentSearchParams.entries()) {
    //   if (value !== '') {
    //     filter[key] = value;
    //   }
    // }
    // await api.getAll(dispatch, [productStart, productSuccess, productFailure, "productlistlastlevel"], 'product/lastlevel', filter, (err, res) => {
    //   if (err) {
    //     dispatch(productFailure());
    //     dispatch(productSuccess({ type: "productlistlastlevel", data: [] }));
    //   } else {
    //     setProductTable(res?.data?.data);
    //   }
    // })

  };


  const filterProduct = async (e) => {
    const keys = ["name"];
    const filteredData = product_last_list?.filter((item) => {
      return keys.some((key) => {
        return item[key].toLowerCase().includes(e.toLowerCase())
      })
    });
    setProductTable(filteredData.length > 0 ? filteredData : []);
    // const prevSearchParams = new URLSearchParams(window.location.search);
    // const mergedSearchParams = new URLSearchParams();
    // for (const [key, value] of prevSearchParams.entries()) {
    //     if (key !== 'search') {
    //       mergedSearchParams.append(key, value);
    //     }
    //   }
    //   mergedSearchParams.set('search', e); 
    //   navigate({
    //   pathname: `${currentLocation}`,
    //   search: `?${mergedSearchParams.toString()}`,
    // });
    // const filter = {};
    // filter.category_id = category_last_list?._id;
    // // Add previous search parameters
    // for (const [key, value] of prevSearchParams.entries()) {
    //   if (value !== '') {
    //     filter[key] = value;
    //   }
    // }
    // await api.getAll(dispatch, [productStart, productSuccess, productFailure, "productlistlastlevel"], 'product/lastlevel', filter, (err, res) => {
    //   if (err) {
    //     dispatch(productFailure());
    //     dispatch(productSuccess({ type: "productlistlastlevel", data: [] }));
    //   }
    // })
  }
 
  const handleRemoveAllQueryParams = () => {
    const url = new URL(window.location.href);
    url.search = ''; // Remove all query parameters
    window.history.replaceState({}, document.title, url);
    getInitProductRelated();
  };

  const handleFilter = (e) => {
    const keys = ["name"];
    const filteredData = category_list?.filter((item) => {
      return keys.some((key) => {
        return item[key].toLowerCase().includes(e.toLowerCase())
      })
    });
    setFinalFilteredData(filteredData);
  }
return (
    <CategorySection>
      
          <><Helmet>
          <title>Our Products | Reachem Chemicals, Bespoke Chemical Products</title>
          <meta
            name="description"
            content={category_last_list?.meta_description?category_last_list?.meta_description:category_last_list?.description ? category_last_list?.description : "Reachem Chemicals, Bespoke Chemical Products"}
          />
          <meta
            name="keywords"
            content={category_last_list?.meta_keywords?category_last_list?.meta_keywords:category_last_list?.description ? category_last_list?.description : "Reachem Chemicals, Bespoke Chemical Products"}
          />
          <link rel="canonical" href={WEB_URL + window.location.pathname} />
        </Helmet>
    
        <div className='head_text'>
      <div className='wrapper'>
      <div className='head_text_align'>
      <h1>Our Products</h1>
      <p>We manufacture the following tailor-made products to meet the requirements of our customers.</p>
      </div>
      </div>

    </div>
        <section className='category_section_last_level'>
          <div className='wrapper'>
            
            <div className='product_listing'>
              <div className='product_listing_left'>
                <Search placeholder="Search Product" onChange={(e)=>filterProduct(e.target.value)} enterButton size='large' />
                <div className='product_category'>
                  <h4>Category</h4>
                  <Menu
                    mode="inline"
                    openKeys={openKeys}
                    onOpenChange={onOpenChange}
                    items={menu}
                    className='product_category_menu'
                  />
                </div>
              </div>
              <div className='product_listing_right'>
                <div className='table_filter'>
                  <Select
                    size='large'
                    defaultValue="Sort By"
                    style={{
                      width: 150,
                    }}
                    onChange={handleChange}
                    options={[
                      {
                        value: 'newtoold',
                        label: 'New to Old',
                      },
                      {
                        value: 'oldtonew',
                        label: 'Old to New',
                      }
                    ]}
                  />
                   {
                    prevSearchParams?.size > 0 &&
                    <Button icon={<CloseOutlined />} size='middle' type='link' onClick={handleRemoveAllQueryParams} className='table_filter_btn' htmlType='button'>
                    Clear
                    </Button>
                   }
                </div>

                <Table
                  columns={columns}
                  pagination={{
                    position: ["topRight"],
                  }}
                  size="middle"
                  dataSource={data}
                  // scroll={{
                  //   x: 1200,
                  //   // y: 300,
                  // }}
                />
              </div>
            </div>
          </div>
        </section>
     </>
        
     
      


    </CategorySection>
  )
}

export default AllProducts;


const CategorySection = styled.section`
  font-family: var(--regular);
  position: relative;
  margin: 50px 0;

a {
  text-decoration: none !important;
  color: inherit !important;
}

.dynamic_category_item h4 {
  color:#c94142
}

.ant-menu-light.ant-menu-inline .ant-menu-item, .ant-menu-light>.ant-menu.ant-menu-inline .ant-menu-item {
  padding-left: 25px !important;
}

.ant-menu-inline .ant-menu-sub.ant-menu-inline>.ant-menu-submenu>.ant-menu-submenu-title {
  padding-left: 25px !important;
}
.ant-menu-light, .ant-menu-light>.ant-menu {
  background: transparent;
}
[class^="ant-menu"] [class^="ant-menu"], [class*=" ant-menu"] [class^="ant-menu"], [class^="ant-menu"] [class*=" ant-menu"], [class*=" ant-menu"] [class*=" ant-menu"] {
  background: white;
  
}
.ant-menu-light:not(.ant-menu-horizontal) .ant-menu-submenu-title:active, .ant-menu-light>.ant-menu:not(.ant-menu-horizontal) .ant-menu-submenu-title:active {
  background: #fff;
}
.ant-menu-light:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover, .ant-menu-light>.ant-menu:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover {
  background: #fff;
}
.ant-menu-light:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):active, .ant-menu-light>.ant-menu:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):active {
  background: #fff;
}
.ant-menu-light:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover, .ant-menu-light>.ant-menu:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover {
  background: #fff;
}

.dynamic_category_list {
  margin: 60px 0;
}
.dynamic_category_item h4 {
  text-align: left;
}
.head_text_align {
  margin: 60px 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
}
.head_text_align h1 {
  font-size: 38px;
}
.head_text_align p {
  max-width: 50%;
  line-height: 1.5;
  margin: auto;
}
.pro-btn button {
    padding: 10px 25px;
    font-size: 16px;
    background: #d55560;
    color: #fff;
    font-weight: 400;
    border: none;
    border-radius: 10px;
    cursor: pointer;
}
.pro-btn {
    position: absolute;
    top:0;
    right:0;
}

.product_listing {
  margin: 0 0 60px;
}

@media screen and (max-width: 1200px) {
  .dynamic_category_list {
    margin: 40px 0;
  }
  .head_text_align p {
    max-width: 100%;
  }
  .pro-btn { 
    position: relative;
  }
}

@media screen and (max-width: 768px) {
  .main_category_description {
    flex-direction: column-reverse;
  }
  .main_category_description_right h4 {
    font-size: 30px;
    text-align: center;
  }
  .main_category_description_right {
    width: 100%;
    margin: 0 0 20px;
  }
  .main_category_description_left {
    width: 100%;
  }
  .product_listing {
    flex-direction: column-reverse;
    gap: 40px;
  }
  .product_listing_left, .product_listing_right {
    width: 100%;
  }
}




`;